import React from 'react';

import { formattedLicensePricingDataType } from 'types/purchaseLicenseModalTypes';
import {
  StyledRecurringChargesContainer,
  StyledLabel,
  StyledFeesText,
} from './RecurringCharges.styles';

const LABEL_TEXT = 'New recurring charges';

interface IRecurringCharges {
  formattedLicensePricingData: formattedLicensePricingDataType;
  didInitialLicensePricingDataApiCallFail: boolean;
}

export const RecurringCharges = ({
  formattedLicensePricingData,
  didInitialLicensePricingDataApiCallFail,
}: IRecurringCharges) => (
  <StyledRecurringChargesContainer>
    <StyledLabel>{LABEL_TEXT}</StyledLabel>
    <StyledFeesText>
      {didInitialLicensePricingDataApiCallFail
        ? '--'
        : `${formattedLicensePricingData?.newRecurringChargesWithoutTaxesAndFees} +
      taxes & fees`}
    </StyledFeesText>
  </StyledRecurringChargesContainer>
);
